import React from 'react'
import { useDrop } from 'react-dnd'
import { ItemTypes } from '../../../../constants'
import ImageContainer from '../ImageContainer'
import canUseDom from 'can-use-dom'
import { get } from 'lodash'
import { Checkbox } from '@material-ui/core'

if (canUseDom) require('./style.scss')

function Placement(props) {
  const { sectionIndex, imageIndex, gallery, saveSubmission, additionalInfo, lead } = props
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.IMAGE,
    drop: () => ({
      placementObject: lead ? 'lead' : [sectionIndex, imageIndex]
    }),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  }), [imageIndex, lead])
  // STY-625: reads the current value off the document being written, not off
  // the render-time prop, so the toggle cannot carry an older document with it.
  const handleChange = (sectionIndex, imageIndex, saveSubmission) => {
    saveSubmission(doc => {
      const carousel = get(doc, `sections[${sectionIndex}].images[${imageIndex}].carousel`, true)
      doc.sections[sectionIndex].images[imageIndex].carousel = !carousel
      return doc
    })
  }
  return (
    <div className='placement-container' ref={drop}>
      <div className='header-container'>
        <div className='header'>{lead ? 'Lead Image' : get(additionalInfo, `sections[${sectionIndex}].images[${imageIndex}].name`, '')}</div>
        {!lead && (
          <div className='checkbox-container'>
            <Checkbox
              name='slider'
              checked={get(additionalInfo, `sections[${sectionIndex}].images[${imageIndex}].carousel`, true)}
              onChange={() => handleChange(sectionIndex, imageIndex, saveSubmission)}
            />
            <div className='checkbox-text'>Carousel</div>
          </div>
        )}
      </div>
      <div className='images-container'>
        {isOver && (
          <div className='dropzone'>
            <div className='dropzone-text'>{`Drag Here To Add To ${lead ? 'Lead Image' : get(additionalInfo, `sections[${sectionIndex}].images[${imageIndex}].name`, '')}`}</div>
          </div>
        )}
        <ImageContainer
          lead={lead}
          additionalInfo={additionalInfo}
          saveSubmission={saveSubmission}
          sectionIndex={sectionIndex}
          imageIndex={imageIndex}
          gallery={gallery}
        />
      </div>
    </div>
  )
}

export default Placement


